import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=2649be12&scoped=true&"
import script from "./BarCharts.vue?vue&type=script&lang=js&"
export * from "./BarCharts.vue?vue&type=script&lang=js&"
import style0 from "./BarCharts.vue?vue&type=style&index=0&id=2649be12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2649be12",
  null
  
)

export default component.exports